import { INSERT_IMAGE_COMMAND, compressImage } from "../image";
import { ToggleButton, Tooltip } from "@mui/material";

import ImageIcon from "@mui/icons-material/Image";
import { styled } from "@mui/material/styles";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useSnackbar } from "../../../hooks";

const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
});

export const ImageInsert = () => {
    const [editor] = useLexicalComposerContext();
    const { openSnackbar } = useSnackbar();
    const loadImage = async (event) => {
        const file = event.target.files?.[0];
        // Reset so that picking the same file again still fires onChange
        event.target.value = "";
        if (!file) return;

        try {
            const src = await compressImage(file);
            editor.dispatchCommand(INSERT_IMAGE_COMMAND, { src });
        } catch (error) {
            console.error(error);
            openSnackbar("Unable to insert this image.", "error");
        }
    };
    return (
        <Tooltip title="Upload image">
            <ToggleButton
                aria-label="upload-image"
                role={undefined}
                component="label"
                tabIndex={-1}
                value="upload-image"
            >
                <ImageIcon />
                <VisuallyHiddenInput
                    type="file"
                    accept="image/*"
                    onChange={loadImage}
                />
            </ToggleButton>
        </Tooltip>
    );
};
